import { getAnalytics, logEvent } from "firebase/analytics";
import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Fade } from "react-reveal";
import Count from "../../components/Count/Count";
import Future from "../../components/Future/Future.component";
import Hero from "../../components/hero/Hero.component";
import Iframe from "../../components/iframe/Iframe.component";
import Review from "../../components/Review/Review.component";
import Slider from "../../components/Slider/Slider.component";
import WhySetu from "../../components/WhySetu/WhySetu";
import Working from "../../components/working/Working.component";
import DiscordIcon from "../../images/Svg/DiscordBlack.svg";
import Faq from "../../pages/Faq/Faq.page";
import { analytics } from "../../utils/firebase";
import { HomepageFaqData, HomepageFaqData2 } from "../Faq/Faq.data";

// export const analytics = getAnalytics();

const Home = () => {
  const handleDiscord = () => {
    logEvent(analytics, "JOIN_DISCORD_CLICKED");
    window.open("https://discord.gg/M9njr5cBBT", "_blank");
  };
  return (
    <main>
      <Iframe />
      <Hero />
      <Count />
      <WhySetu />
      <Working />
      <Slider />
      <Fade cascade duration={1000}>
        <Faq
          title={"Join Our Conversations"}
          t1={HomepageFaqData}
          t2={HomepageFaqData2}
        />
      </Fade>
      {/* <Follow /> */}
      <Future />

      <a onClick={handleDiscord}>
        <div className="rounded-full p-5 text-center bg-[#FFFFFF] shadow-lg w-[88px] h-[88px] cursor-pointor fixed right-[24px] bottom-[24px]  drop-shadow-2xl	 border-1">
          <img width={"36px"} className="mx-auto" src={DiscordIcon} alt="" />
          <h1 className="text-sm font-bold mt-1">Join Us</h1>
        </div>
      </a>
    </main>
  );
};

export default Home;
